import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { copyJSON, removeItemFromArrayById, updateItemInArrayById } from '../../core/util/helpers';
import { PagedResults, Product } from '../../core/types';

export interface PagedProductList extends PagedResults {
  items: Product[]
}

interface ProductsState {
  loading: boolean;
  error: string | null;
  pagedProductList: PagedProductList | null;
  deleteProductId: number | null;
  patchProductId: number | null;
  redirectToPattern: string | null;
  patchProductRegistered: string;
}

export const initialState: ProductsState = {
  loading: false,
  error: null,
  pagedProductList: null,
  deleteProductId: null,
  patchProductId: null,
  redirectToPattern: null,
  patchProductRegistered: ''
};

export const productListSlice = createSlice({
  name: 'productList',
  initialState,
  reducers: {
    fetchProductListStart: (state) => {
      state.loading = true;
    },
    fetchProductListSuccess: (state, action: PayloadAction<PagedProductList>) => {
      state.pagedProductList = action.payload;
      state.loading = false;
    },
    fetchProductListError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
      state.loading = false;
    },
    resetProductList: (state) => {
      state.pagedProductList = null;
      state.loading = false;
      state.error = null;
      state.deleteProductId = null;
    },
    setPatchProductIdRegistered: (state, action: PayloadAction<{id: number | null, registered: string}>) => {
      state.patchProductId = action.payload.id;
      state.patchProductRegistered = action.payload.registered;
      state.loading = false;
    },
    patchProductUpdateList: (state, action: PayloadAction<any>) => {
      state.loading = false;
      if (!!state.pagedProductList && state.patchProductId) {
        state.pagedProductList.items = updateItemInArrayById(
                                        copyJSON(state.pagedProductList.items) as Product[],
                                        state.patchProductId,
                                        state.patchProductRegistered 
                                      ) as Product[];  
        state.patchProductId = null;
        }
        
    },
    patchProductError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
      state.loading = false;
    },
    setDeleteProductId: (state, action: PayloadAction<number|null>) => {
      state.deleteProductId = action.payload;
    },
    deleteProductSuccess: (state) => {
      if (!!state.pagedProductList && state.deleteProductId) {
        state.pagedProductList.items = removeItemFromArrayById(
                                        copyJSON(state.pagedProductList.items) as Product[],
                                        state.deleteProductId
                                       ) as Product[];
        state.deleteProductId = null;
      }
    },
    deleteProductError: (state) => {
      state.deleteProductId = null;
    }
  }
});

export const {
  fetchProductListStart,
  fetchProductListSuccess,
  fetchProductListError,
  resetProductList,
  setPatchProductIdRegistered,
  patchProductUpdateList,
  patchProductError,
  setDeleteProductId,
  deleteProductSuccess,
  deleteProductError
} = productListSlice.actions;

export default productListSlice.reducer;
